import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import translate from "../../translation";
import { Empty, Loading, RadioItem, ShareModal } from "../../components";
import { scrollTop } from "../../helpers/behavior";
import { IoPlay } from "react-icons/io5";
import { TiMediaPause } from "react-icons/ti";
import {
	SET_PLAYER,
	SET_RADIO_PROGRAM_LOADING,
	SET_SERIES_PODCAST,
	SET_CURRENT_RADIOS_STREAMS,
} from "../../store/actions/constants";
import { useNavigate, useParams } from "react-router-dom";
import { getRadioById, getSameParentRadios } from "../../store/actions/radio";
import { getPodcastsBrand } from "../../store/actions/podcasts";
import { getRadioPrograms } from "../../store/actions/program";
import { site_url } from "../../config/keys";
import { getNextSevenDays } from "../../helpers/radio";
import { Helmet } from "react-helmet";
import moment from "moment";
import EmissionItem from "./childs/EmissionItem";
import PodcastItem from "./childs/PodcastItem";
import { getStreamsRadioById } from "../../store/actions/radio";

const Single = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { rpID } = useParams();
	const currentId = rpID?.split("-")[0];
	const { playing, stream: playedRadio } = useSelector((state) => state.player);
	const { currentRadio, sameParentRadios } = useSelector((state) => state.radio);
	const { podcastsBrand } = useSelector((state) => state.podcasts);
	const { emissions, loading } = useSelector((state) => state.program);
	const [selectedDay, setSelectedDay] = useState({
		label: moment().format("dddd"),
		value: moment().format("YYYY-MM-DD"),
	});
	const [showShare, setShowShare] = useState(false);
	const days = getNextSevenDays();
	const { innerWidth: width } = window;
	const radio_url = `${site_url}/radio/${currentRadio.rpID}-${currentRadio.nom?.trim()?.replace(/ /g, "-")}`;

	useEffect(() => {
		scrollTop();
	}, [currentRadio]);
	useEffect(() => {
		dispatch({ type: SET_SERIES_PODCAST, payload: [] });
		dispatch({ type: SET_CURRENT_RADIOS_STREAMS, payload: [] });
	}, [dispatch]);
	useEffect(() => {
		dispatch(getRadioById(currentId, navigate));
	}, [dispatch, currentId, navigate]);

	useEffect(() => {
		dispatch(getSameParentRadios(currentId));
	}, [dispatch, currentId]);

	useEffect(() => {
		dispatch({ type: SET_RADIO_PROGRAM_LOADING, payload: true });
		dispatch(getRadioPrograms(currentId, { date: selectedDay.value }));
	}, [dispatch, currentId, selectedDay]);

	useEffect(() => {
		dispatch(getPodcastsBrand());
	}, [dispatch]);
	const handleOnPlay = async () => {
		const startPlaying = !(playing && playedRadio.rpID === currentRadio.rpID);
		if (startPlaying) {
			dispatch(await getStreamsRadioById(currentRadio.rpID, navigate));
		}
		const payload = {
			playing: startPlaying,
			stream: {
				nom: currentRadio.nom,
				description: currentRadio.description,
				rpID: currentRadio.rpID,
				image: currentRadio.image?.url,
				stream: currentRadio.stream,
				url: "",
			},
			playedSeconds: 0,
			isRadio: true,
			userClick: true,
		};
		if (!startPlaying) payload.lastRpidPlayed = currentRadio.rpID;
		dispatch({ type: SET_PLAYER, payload: payload });
	};
	const isRadioBrand = podcastsBrand.some((radio) => radio.rpId === currentRadio.rpID);
	const onShare = () => {
		if (width >= 768) {
			setShowShare(true);
		} else {
			if (navigator.share) {
				navigator
					.share({
						url: `${site_url}/radio/${currentRadio.rpID}-${currentRadio.nom?.trim()?.replace(/ /g, "-")}`,
					})
					.then(() => {})
					.catch(console.error);
			} else {
				setShowShare(true);
			}
		}
	};

	const onClickDay = (day) => {
		setSelectedDay(day);
	};

	return (
		<div id="singlePage">
			<Helmet>
				<title>{`Ecouter ${currentRadio.nom} sur Radioplayer - Radio & Podcast en streaming`}</title>
				<meta name={translate("descripton")} content={currentRadio.description} />
				<meta name="robots" content={"radio, streaming, podcast, gratuit, mp3, aac"} />
				<meta property="og:title" content={currentRadio.nom} />
				<meta property="og:description" content={currentRadio.description} />
				<meta property="og:image" content={currentRadio?.image?.url} />
				<meta property="og:url" content={radio_url} />
			</Helmet>
			<section className="section1">
				<Container>
					<Row>
						<Col md={{ span: 8, offset: 2 }} className="text-center">
							<div
								className="radioImg"
								style={{
									backgroundImage: `url(${currentRadio?.image?.url})`,
								}}
							></div>
							<h2>{currentRadio.nom}</h2>
							<p>{currentRadio.description}</p>
							{(currentRadio.facebook || currentRadio.twitter) && (
								<div className="social">
									{currentRadio.facebook && (
										<Button
											className="facebook"
											href={"https://facebook.com/" + currentRadio.facebook}
											target="_blank"
										/>
									)}
									{currentRadio.twitter && (
										<Button
											className="twitter"
											href={"https://twitter.com/" + currentRadio.twitter}
											target="_blank"
										/>
									)}
								</div>
							)}
							{currentRadio.site && (
								<Button variant="site" href={currentRadio.site} target="_blank">
									{translate("Site officiel")}
								</Button>
							)}
							<div className="col buttonsWrapper">
								<Button variant="share" onClick={onShare}>
									{translate("Partager")}
								</Button>
							</div>
						</Col>
					</Row>
					<Row>
						<Col className="text-center">
							<Button onClick={handleOnPlay} variant="play">
								{playing && playedRadio.rpID === currentRadio.rpID ? (
									<TiMediaPause color="#000" size={55} />
								) : (
									<IoPlay color="#000" size={45} />
								)}
							</Button>
						</Col>
					</Row>
				</Container>
			</section>
			<section className="section2">
				{emissions.length > 0 && (
					<Container>
						<h2 className="title">{translate("Les émissions de") + " " + currentRadio.nom}</h2>
						<Row>
							<Col md={{ span: 10, offset: 1 }} className="text-center days-con">
								{days.map((day) => (
									<Button
										variant="tab"
										onClick={() => onClickDay(day)}
										className={selectedDay.label === day.label && "active"}
										key={day?.label?.toString()}
									>
										{translate(day.label)}
									</Button>
								))}
							</Col>
						</Row>
						<Row>
							<Col md={{ span: 10, offset: 1 }}>
								<div className="emissionsCon">
									{loading ? (
										<Loading color="black" size={30} conClass="loading" />
									) : emissions.length === 0 ? (
										<Empty text={translate("Aucune emission ce jour")} />
									) : (
										emissions.map((emission, index) => (
											<EmissionItem
												item={emission}
												currentRadio={currentRadio}
												key={index?.toString()}
											/>
										))
									)}
								</div>
							</Col>
						</Row>
					</Container>
				)}
			</section>
			<section className="section4">
				{isRadioBrand ? (
					<div>
						<h2 className="title">{translate("Les podcasts de") + " " + currentRadio.nom}</h2>
						<div className="carousel">
							<PodcastItem item={podcastsBrand} currentRadioId={currentRadio.rpID} />
						</div>
					</div>
				) : null}
			</section>
			{sameParentRadios.length > 0 && (
				<section className="section3">
					<Container>
						<h2 className="title">{translate("Les autres radios de") + " " + currentRadio.nom}</h2>
						<div className="radiosBlock">
							{sameParentRadios.map((item) => (
								<RadioItem key={item?.rpID?.toString()} item={item} />
							))}
						</div>
					</Container>
				</section>
			)}
			<ShareModal
				//title={translate("ShareTitle")}
				shareUrl={radio_url}
				show={showShare}
				onHide={() => setShowShare(false)}
			/>
		</div>
	);
};

export default Single;
